import React from "react";
import { notification } from "antd";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaInfoCircle,
  FaExclamationCircle,
} from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import "../../styles/CustomNotification.css";

type NotificationType = "success" | "error" | "info" | "warning";

interface NotificationProps {
  type: NotificationType;
  message: string | object;
}

const notificationStyles: Record<
  NotificationType,
  { background: string; borderColor: string; iconColor: string }
> = {
  success: {
    background: "#f6ffed",
    borderColor: "#b7eb8f",
    iconColor: "#52c41a",
  },
  error: {
    background: "#fff1f0",
    borderColor: "#ffa39e",
    iconColor: "#ff4d4f",
  },
  info: {
    background: "#e6f7ff",
    borderColor: "#91d5ff",
    iconColor: "#1890ff",
  },
  warning: {
    background: "#fffbe6",
    borderColor: "#ffe58f",
    iconColor: "#faad14",
  },
};

const openNotification = ({ type, message }: NotificationProps): void => {
  const { background, borderColor, iconColor } = notificationStyles[type] || {};

  let icon: React.ReactNode;

  switch (type) {
    case "success":
      icon = <FaCheckCircle style={{ color: iconColor }} />;
      break;
    case "error":
      icon = <FaTimesCircle style={{ color: iconColor }} />;
      break;
    case "info":
      icon = <FaInfoCircle style={{ color: iconColor }} />;
      break;
    case "warning":
      icon = <FaExclamationCircle style={{ color: iconColor }} />;
      break;
    default:
      icon = null;
  }

  // Handle message type: if it's an object, convert it to a string
  const messageContent =
    typeof message === "object" ? JSON.stringify(message) : message;

  notification.open({
    message: messageContent,
    className: "custom-notification",
    style: {
      backgroundColor: background,
      borderColor: borderColor,
      color: "#000",
      borderRadius: "0.3125rem",
      borderLeft: `0.3125rem solid ${iconColor}`,
      top: "3rem",
    },
    icon: icon,
    closeIcon: (
      <span>
        <IoClose className="notification-close-button" />
      </span>
    ),
  });
};

export default openNotification;
